export const frontendUserManageMinimalPoolAbi = [
  {
    name: "userManageMinimalPoolInfo",
    inputs: [
      {
        name: "pool",
        type: "address",
        internalType: "address",
      },
      {
        name: "who",
        type: "address",
        internalType: "address",
      },
      {
        name: "router",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        internalType: "struct Frontend_UserManageMinimalPoolInfo.UserManageMinimalPoolInfoStruct",
        name: "",
        type: "tuple",
        components: [
          {
            name: "A",
            type: "address[3]",
            internalType: "address[3]",
          },
          {
            name: "N",
            type: "uint256[16]",
            internalType: "uint256[16]",
          },
        ],
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const
